import { Size } from '../size';
import { EndCapStyle } from './enums';

/** Describes a coordinate point. */
export interface ArrowCap {
  /** Size of the arrow. */
  size: Size;
  /** Style of the arrow. */
  style: EndCapStyle;
}

/**
 * Creates an ArrowCap from a size and style.
 */
export const createArrowCap = (
  size: Size = { height: 0, width: 0 },
  style: EndCapStyle = EndCapStyle.None
): ArrowCap => ({ size, style });
